import { createContext, useContext } from 'react';
export const WebPlatformContext = createContext({
    env: {
        isPublicDNS: false,
        isLocalhost: false,
        isPplxDev: false,
        isPreview: false,
        isStaging: false,
        isBeta: false,
        isTesting: false,
        isAskDev: false,
        isDevBox: false,
        isNamedDevDomain: false,
        isProduction: false,
        isSandbox: false,
        isDevDeployment: false,
        isSingleTenant: false,
        envHasDevLogins: false,
        deployName: '',
    },
    hostname: '',
    device: {
        isChrome: false,
        isMobile: false,
        isAndroid: false,
        isIOS: false,
        isIPad: false,
        isMacOS: false,
        isFirefox: false,
        isMobileSafari: false,
        isWindowsOS: false,
        isLinuxOS: false,
        isWindowsApp: false,
        isMetaBrowser: false,
        isSamsungBrowser: false,
        userAgent: '',
    },
});
WebPlatformContext.displayName = 'WebPlatformContext';
export const useWebPlatform = () => {
    const ctx = useContext(WebPlatformContext);
    if (!ctx) {
        throw new Error('useWebPlatform must be used within WebPlatformContext');
    }
    return ctx;
};
//# sourceMappingURL=useWebPlatform.js.map